import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            重磅推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            焦点爆料
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            编辑精选深度调查报道，每篇都值得细读
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item, idx) => (
            <article
              key={item.id}
              className={`rounded-lg overflow-hidden bg-background-200/70 border border-background-300/50 group cursor-pointer transition-all duration-300 hover:border-primary-500/30 ${
                idx === 0 ? 'lg:col-span-3' : ''
              } ${idx >= 1 && idx <= 2 ? 'lg:col-span-1' : idx >= 3 ? 'lg:col-span-1' : ''}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    idx === 0 ? 'h-48 md:h-72' : 'h-44 md:h-52'
                  }`}
                  loading={idx > 0 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/80 via-transparent to-transparent" />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-500/90 text-foreground-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500/90 text-background-900 whitespace-nowrap">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className={`font-bold text-foreground-50 group-hover:text-primary-400 transition-colors font-heading ${
                  idx === 0 ? 'text-lg md:text-xl' : 'text-sm md:text-base'
                }`}>
                  {item.title}
                </h3>
                <p className={`text-foreground-500 mt-2 leading-relaxed ${
                  idx === 0 ? 'text-sm' : 'text-xs md:text-sm'
                }`}>
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}